import { IAliasJumpTo, IAliasOption } from './types';
import { GraphQLUserAliasId } from '../../utils/types';

/**
 * Create "Jump to..." option for each alias which is registered in the `aliasAnchors` list
 *
 * @param aliases - list of current aliases
 * @param aliasAnchors - alias IDs that are currently displayed in the builder. The list may contain extra or fewer
 * alias IDs than `aliases`
 * @param jumpToHandler - a function that should perform "Jump to" operation (e.g. to scroll & highlight the anchor)
 */
export const appendJumpToOptions = (
  aliases: IAliasOption[],
  aliasAnchors: Array<GraphQLUserAliasId>,
  jumpToHandler: (aliasId: GraphQLUserAliasId) => void,
) => {
  const jumpToOptions: IAliasJumpTo[] = [];
  for (const alias of aliases) {
    if (alias.type === 'alias') {
      if (aliasAnchors.includes(alias.userAliasId)) {
        jumpToOptions.push({
          type: 'jumpTo',
          userAliasId: alias.userAliasId,
          name: `Jump to ${alias.name}`,
          jumpToHandler: () => jumpToHandler(alias.userAliasId),
        });
      }
    }
  }
  if (jumpToOptions.length !== 0) {
    aliases.push({ type: 'divider' }, ...jumpToOptions);
  }
};
